<template>
  <div
    class="app-cards"
    :class="{
      'horizontal-flow': horizontal,
      colorize,
      compact,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppCards',

  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },

    compact: {
      type: Boolean,
      default: false,
    },

    colorize: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';
@import '@/styles/functions.scss';

.app-cards {
  display: flex;
  flex-direction: column;

  &.colorize {
    :deep(> .app-card) {
      @each $color in $colors {
        $index: index($colors, $color);
        $backgroundColor: nth($color, 2);
        $textColor: get-text-color($backgroundColor);

        &:nth-child(#{$index}) {
          color: $textColor;
          background-color: $backgroundColor;
        }
      }
    }
  }

  &.horizontal-flow {
    flex-direction: row;

    > .app-card {
      margin-top: 0;
      margin-left: 0.5rem;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
